import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteSport = async (ID) => {
  try {
    const SportDocument = doc(db, "Sports", ID);

    await updateDoc(SportDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteSport;
